import React, { useState } from 'react'
import PasswordOpen from '../../../Images/passwordeyeopen.png'
import PasswordClose from '../../../Images/passwordeyeclose.png'
import FamilyLoginPopup from './FamilyLoginPopup';
import useLogin from '../hooks/useLogin';
import ForgetPasswordPopup from './ForgetPasswordPopup';

function LoginForm({  isTop = false, dropdownData ,onClose, isFromLandingPage ,pathname}) {
    const [showFamilyLoginPopup, setShowFamilyLoginPopup] = useState(false)
    const [showForgetpassword, setShowForgetpassword] = useState(false)
    const { isLoginLoading, login,validateLoginForm,loginErrors } = useLogin()

    const [formData, setFormData] = useState({ 
        email: '',
        password: '',
        remember: false,
    });
    const [showPassword, setShowPassword] = useState(false)





    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData({
            ...formData,
            [name]: type === 'checkbox' ? checked : value,
        });
    };



    const handleSubmit = (e) => {
        e.preventDefault();
        if (validateLoginForm(formData)) {
            login(formData)
        }
    };

    const openFamilyLoginPopup = () => {
        setShowFamilyLoginPopup(true)
        // setTimeout(()=>{
        //     onClose()
        // },2000)
        
    }

    const closeFamilyLoginPopup = () => {
        setShowFamilyLoginPopup(false)
    }

    return (
        <>
            {showFamilyLoginPopup && <FamilyLoginPopup onClose={closeFamilyLoginPopup} dropdownData={dropdownData}/>}
            {showForgetpassword &&  <ForgetPasswordPopup onClose={()=>setShowForgetpassword(false)}/>}
            {isFromLandingPage ?
                <form
                    onSubmit={handleSubmit}
                    className="login-section"
                    id="loginForm"
                >
                   
                    <div>
                        <p onClick={openFamilyLoginPopup} style={{textAlign: 'end', paddingLeft: '20rem', whiteSpace: 'nowrap', marginTop: '8px'}} id="familymemberbtn" className="loginfamily">Login as Family Member/ Friend</p>
                    </div>
                    <div class="flex-container">
                        <div class="error loginApiError"></div>

                        <div class={` ${pathname==="/online-matrimony-site"? "login-flex-container":"emaillogin-flex-container"}`} style={{columnGap: '1.5rem', marginTop: '0.7rem'}}>
                            <div class=" formdivheader">
                                <div>
                                    <label style={{position: "relative"}}>
                                        <input
                                            id="loginEmailId"
                                            name="email"
                                            type="text"
                                            value={formData?.email}
                                            onChange={handleInputChange}
                                            autoComplete="off"
                                            placeholder="e-mail ID / Mobile Number"
                                            className="form-control  top-forminput   emailinput loginEmail"
                                        />
                                    </label>
                                </div>
                                
                                <div>
                                    <label className=" termslabel" style={{position: "relative"}}>
                                        <input
                                            name="remember"
                                            type="checkbox"
                                            className="appcheckbox"
                                            autoComplete="off"
                                            value=""
                                        />
                                        <span className=" termstext">
                                            <p className="rememberText">Keep me logged in</p>
                                        </span>
                                    </label>
                                    <br />
                                </div>
                                
                            </div>
                            <div class=" formdivheader">
                                <div>
                                    <label className="pswlabel">
                                        <input
                                            id="loginPsw"
                                            name="password"
                                            type={showPassword ? "text" : "password"}
                                            value={formData?.password}
                                            onChange={handleInputChange}
                                            
                                            autoComplete="off"
                                            placeholder="Password"
                                            className="form-input top-passwordinput loginPassowrd"
                                        />
                                        <div onClick={() => setShowPassword(prev => !prev)} className="hideicon">
                                            {showPassword
                                                ? <img
                                                    src={PasswordClose}
                                                    className="eyeicon"
                                                    alt="eyeclose"
                                                />
                                                : <img
                                                    src={PasswordOpen}
                                                    className="eyeicon"
                                                    alt="eyeopen"
                                                />}
                                        </div>
                                    </label>
                                </div>
                            
                                <p onClick={()=>setShowForgetpassword(true)} className="rememberText cursor-pointer" style={{textAlign: 'end'}}>
                                    Forgot Password?
                                </p>
                            </div>
                            
                            
                            <label class="signbuttonlabel ">
                                <button disabled={isLoginLoading} type="submit" class="loginbtn ">LOG IN</button>
                            </label>
                                
                            
                        </div>
                        
                        
                    </div>

                </form> :
            isTop
                ? <form onSubmit={handleSubmit} className="loginFormheader" id="loginFormHeader">
                    <div className="error loginApiError"></div>
                    <div className="formdivinput">
                        <div className=" formdivheaderinput">
                            <div>
                                <label className="formlabel ">
                                    <input
                                        id="loginEmail"
                                        name="email"
                                        type="text"
                                        disabled={isLoginLoading}
                                        value={formData?.email}
                                        onChange={handleInputChange}
                                        autoComplete="off"
                                        placeholder="e-mail ID / Mobile Number"
                                        className="form-control  forminput   emailinput loginEmail"
                                    />
                                </label>
                                {loginErrors?.password && <div className="errormsgs">{loginErrors?.password}</div>}
                            </div>
                        </div>
                        <div className="">
                            <div>
                                <label className="formlabel termslabel">
                                    <input
                                        id="terms"
                                        name="remember"
                                        type="checkbox"
                                        className="appcheckbox"
                                        autoComplete="off"
                                        value=""
                                    />
                                    <span className=" termstext">
                                        <p className="remembertext">Keep me logged in</p>
                                    </span>
                                </label>
                                <br />
                            </div>
                        </div>
                        <div className="errormsgs loginEmailError"></div>

                    </div>
                    <div className="formdivinput">

                        <div className=" formdivheaderinput">
                            <div>
                                <label className="pswlabel">
                                    <input
                                        id="loginPassowrd"
                                        name="password"
                                        autoComplete="off"
                                        disabled={isLoginLoading}
                                        placeholder="Password"
                                        type={showPassword ? "text" : "password"}
                                        value={formData?.password}
                                        onChange={handleInputChange}
                                        className="form-input passwordinput loginPassowrd"
                                    />
                                    <div onClick={() => setShowPassword(prev => !prev)} className="hideicon">
                                        {showPassword
                                            ? <img
                                                src={PasswordClose}
                                                className="eyeicon"
                                                alt="eyeclose"
                                            />
                                            : <img
                                                src={PasswordOpen}
                                                className="eyeicon"
                                                alt="eyeopen"
                                            />}
                                    </div>
                                </label>
                                {loginErrors?.password && <div className="errormsgs">{loginErrors?.password}</div>}
                                {loginErrors?.loginError && <div className="errormsgs">{loginErrors?.loginError}</div>}


                            </div>

                        </div>
                        <p onClick={()=>setShowForgetpassword(true)} id="forgetpasswordBtn" className="remembertext cursor-pointer">
                            Forgot Password?
                        </p>
                        <div className="errormsgs loginPasswordError"></div>
                    </div>
                    <div className="">
                        <div>
                            <label className="buttonlabelinput ">
                                <button disabled={isLoginLoading} type="submit" className="signintbtn ">{isLoginLoading ? "Signing In..." : "Sign In"}</button>
                            </label>
                        </div>
                    </div>
                </form>
                : <form
                    onSubmit={handleSubmit}
                    className="loginForm"
                    id="loginForm">
                    <div className="error loginApiError"></div>
                    <div className=" formdivheader">
                        <div>
                            <label className="formlabel ">
                                <input
                                    id="loginEmailId"
                                    name="email"
                                    type="text"
                                    value={formData?.email}
                                    onChange={handleInputChange}
                                    autoComplete="off"
                                    placeholder="e-mail ID / Mobile Number"
                                    className="form-control  forminput   emailinput loginEmail"
                                />
                            </label>
                        </div>
                        {loginErrors?.password && <div className="errormsgs">{loginErrors?.password}</div>}
                    </div>
                    <div style={{marginTop:"1rem"}} className=" formdivheader">
                        <div>
                            <label className="pswlabel">
                                <input
                                    id="loginPsw"
                                    name="password"
                                    type={showPassword ? "text" : "password"}
                                    value={formData?.password}
                                    onChange={handleInputChange}
                                    
                                    autoComplete="off"
                                    placeholder="Password"
                                    className="form-input passwordinput loginPassowrd"
                                />
                                <div onClick={() => setShowPassword(prev => !prev)} className="hideicon">
                                    {showPassword
                                        ? <img
                                            src={PasswordClose}
                                            className="eyeicon"
                                            alt="eyeclose"
                                        />
                                        : <img
                                            src={PasswordOpen}
                                            className="eyeicon"
                                            alt="eyeopen"
                                        />}
                                </div>
                            </label>
                        </div>
                        {loginErrors?.password && <div className="errormsgs">{loginErrors?.password}</div>}
                    </div>
                    <p onClick={openFamilyLoginPopup} id="familymemberbtn" className="loginfamily">
                        Login as Family Member/
                        Friend
                    </p>
                    {loginErrors?.loginError && <div style={{marginTop:"1rem"}} className="errormsgs">{loginErrors?.loginError}</div>}
                    <div style={{ "justifyContent": "space-between", "alignItems": "center" }}>
                        <div className="labeldiv">
                            <div>
                                <label className="formlabel termslabel">
                                    <input
                                        name="remember"
                                        type="checkbox"
                                        className="appcheckbox"
                                        autoComplete="off"
                                        value=""
                                    />
                                    <span className=" termstext">
                                        <p className="rememberText">Keep me logged in</p>
                                    </span>
                                </label>
                                <br />
                            </div>
                        </div>
                        <p onClick={()=>setShowForgetpassword(true)} id="forgetpasswordBtnpopup" className="forgotpsw rememberText cursor-pointer">
                            Forgot Password?
                        </p>
                    </div>
                    <div className="labeldiv">
                        <div>
                            <label className="buttonlabel ">
                                <button disabled={isLoginLoading} type="submit" className="submitbtn ">{isLoginLoading ? "Signing In..." : "Sign In"}</button>
                            </label>
                        </div>
                    </div>
                </form>}
        </>
    )
}

export default LoginForm